export default {"src":"/_next/static/media/IPLIcon.a3830fcb.svg","height":90,"width":131};